import { defineComponent as _defineComponent } from 'vue'
import { vModelCheckbox as _vModelCheckbox, createElementVNode as _createElementVNode, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1a3e2890"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["for"]
const _hoisted_2 = ["id", "value"]

import { computed } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'TressCheckboxListItem',
  props: {
    value: {},
    label: {},
    id: {},
    modelValue: {}
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit: emits }) {

const props = __props;





const _modelValue = computed({
  get: () => props.modelValue,
  set: (val: string[]) => {
    emits("update:modelValue", val);
  },
});

const _id = computed(() => props.id || props.label.toLowerCase());

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("label", {
    class: "checkbox-item__label",
    for: _id.value
  }, [
    _withDirectives(_createElementVNode("input", {
      class: "checkbox-item__input",
      type: "checkbox",
      id: _id.value,
      value: _ctx.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_modelValue).value = $event))
    }, null, 8, _hoisted_2), [
      [_vModelCheckbox, _modelValue.value]
    ]),
    _createTextVNode(" " + _toDisplayString(_ctx.label), 1)
  ], 8, _hoisted_1))
}
}

})